import Modal from "~/common/components/Modal";
import { replaceUnderscoresUpperCase } from "~/common/utils";
import {
  domainTextStyle,
  FUNCTIONAL_DOMAINS_INFO_MODAL_KEYS_OPTIONS,
  getFunctionalDomainsInfoModalText,
} from "~/providers/utils/getFunctionalDomainsInfoModalText";

interface FunctionalDomainsModalProps {
  show: boolean;
  onClose: () => void;
}

export const FunctionalDomainsModal = ({
  show,
  onClose,
}: FunctionalDomainsModalProps) => (
  <Modal
    className="h-fit max-h-[80vh] xl:w-1/2"
    titleClassName="text-xl font-semibold text-gray-70"
    title="Functional domains"
    show={show}
    onClose={onClose}
  >
    <div className="flex flex-col gap-4 text-sm text-gray-700">
      <p>
        Functional Domains are areas of a person’s life that reflect how they
        think, feel, behave, and engage with their environment, providing a
        holistic view of their overall well-being.
      </p>
      <ul className="flex list-disc flex-col gap-4 pl-6">
        {FUNCTIONAL_DOMAINS_INFO_MODAL_KEYS_OPTIONS.map((key) => (
          <li key={key}>
            <span className={domainTextStyle({ status: key })}>
              {replaceUnderscoresUpperCase(key)}:
            </span>{" "}
            {getFunctionalDomainsInfoModalText(key)}
          </li>
        ))}
      </ul>
    </div>
  </Modal>
);
